


















































































































































































































































import { Component } from 'vue-property-decorator';
import { envCongif } from '@/shared/env.config';
import { State } from 'vuex-class';
import { RootStoreState } from '@/store';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { MswAppTitle } from '@/shared/msw-app-title';
import { SelectOption, SwSelect } from '@libs-uuif/shared/sw-select';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SwTextfield, SwTextarea } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwForm, SwFormRow,  SwFormRowError } from '@libs-uuif/shared/sw-form';
import { SwActionBar, SwActionBarItem } from '@sonicwall/unified-ui-framework/src/shared/sw-action-bar';
import { required, helpers } from 'vuelidate/lib/validators';
import RecaptchaComponent from '@/shared/captchaComponent/RecaptchaComponent.vue';
import RegexValidators from '@/shared/regex-validators';
import { localStorageKeeperService } from '@/shared/auth-service';
import { currentUserKey } from '@/shared/msw-constants';
import { messageService } from '@sonicwall/unified-ui-framework/src/shared/message-service';
import axios from 'axios';
import { PageTitleConfig } from '@/shared/msw-app-title/type';

const emailPatternCheck = helpers.regex('emailPattern', new RegExp(RegexValidators.email));
const cssPrefix = 'msw-sign-issues';
@Component({
  components: {
    MswAppTitle,
    SwButton,
    SwTextfield,
    SwTextarea,
    SwSelect,
    SwForm,
    SwFormRow,
    SwFormRowError,
    SwActionBar,
    SwActionBarItem,
    RecaptchaComponent,
  },
  validations: {
    emailAddress: { required, emailPatternCheck },
    category: { required },
    issueType: { required },
    comments: { required },
    file: { required },
  },
})
export default class MswSignatureIssues extends SwExtendedVue {

  @State((state: RootStoreState) => state.CoreStoreModule.loggedIn)
  loggedIn: boolean;

  cssPrefix = cssPrefix;
  fileURL: string = '';
  emailAddress: string = '';
  category: string = 'GAV';
  issueType: string = 'FN';
  comments: string = '';
  signatureID: string = '';
  sfdc: string = '';
  file: any = '';
  notZipFile: boolean = false;
  captchaResponse: string = '';
  siteKey: string = '6Lcf40MsAAAAAC1dHWLEkq7DfUwS1SlLEo3-LD2X';

  categoryOptions: SelectOption[] = [
    { id: 'GAV' , label: 'Gateway Antivirus', value: 'GAV' },
    { id: 'IDP' , label: 'Intrusion Prevention System', value: 'IDP' },
    { id: 'AppControl' , label: 'Application Control', value: 'AppControl' },
    { id: 'ES' , label: 'Email Security', value: 'ES' },
  ];

  issueTypeOptions: SelectOption[] = [
    { id: 'FN' , label: 'False Negative', value: 'FN' },
    { id: 'FP' , label: 'False Positive', value: 'FP' },
  ];

  handleFileInput(event:any) {
    this.file = event.target.files[0];
    if (this.file.type !== 'application/zip') {
      this.notZipFile = true;
    } else {
      this.notZipFile = false;
    }
  }

  resetForm() {
    this.$v!.emailAddress!.$reset();
    this.$v!.category!.$reset();
    this.$v!.issueType!.$reset();
    this.$v!.comments!.$reset();
    this.$v!.file!.$reset();
    this.signatureID = '';
    this.sfdc = '';
    this.fileURL = '';
  }

  async submit() {
    if (this.checkIfInputValid() && !this.notZipFile) {
      const today = new Date();
      /* tslint:disable-next-line */
      const escapeRecaptcha = this.isLoggedIn() ? window.btoa(this.emailAddress + '#' + today.toLocaleDateString().replace(/[^ -~]/g, '') + '#' + this.siteKey) : '';
      if (!this.isLoggedIn()) {
        let result: { status: string; response: string; msg: string; } = { status: '', response: '', msg: '' };
        result = (this.$refs['recaptchaComponentForSign'] as RecaptchaComponent)?.fetchCaptcha() || { status: '', response: '', msg: '' };
        if (result && result.status === 'error') {
          messageService.messageManager.showMessage('login-message',  result?.msg , 'failed');
          return;
        }
        this.captchaResponse = result.response ? result.response : '';
        console.warn(this.captchaResponse);
      } else {
        this.captchaResponse = '';
      }
      const currentUser = localStorage.getItem(currentUserKey);
      const token = currentUser && JSON.parse(currentUser) ? JSON.parse(currentUser).token : '';
      console.warn(token);
      const formData = new FormData();
      formData.append('Authorization', this.isLoggedIn ? token : '');
      formData.append('emailAddress', this.emailAddress);
      formData.append('category', this.category);
      formData.append('issueType', this.issueType);
      formData.append('fileUrl', this.fileURL);
      formData.append('comments', this.comments);
      formData.append('signatureID', this.signatureID);
      formData.append('sfdcID', this.sfdc);
      formData.append('fieldNameHere', this.file.name);
      formData.append('captchaText', this.captchaResponse);
      formData.append('sourceName', escapeRecaptcha);
      formData.append('file', this.file);
      this.$store.commit('startLoading');
      await axios.post(`${envCongif.api_url}/signature-issues`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response:any) => {
        this.$store.commit('stopLoading');
        const resp:any = response.data;
        console.warn(resp);
        if (resp.operationStatus === 'NOK') {
          console.warn('Returning NOK');
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
          this.resetForm();
        }
      })
      .catch((err:any) => {
        this.$store.commit('stopLoading');
        console.error(err);
        this.$store.commit(
          'enqueueMessage',
          {
            infoType: 'failed',
            infoMsg: this.$t('systemMessages.wrong')
            .toString(),
          },
        );
      });
    }
  }

  checkIfInputValid():boolean {
    this.$v!.emailAddress!.$touch();
    this.$v!.category!.$touch();
    this.$v!.issueType!.$touch();
    this.$v!.comments!.$touch();
    this.$v!.file!.$touch();
    if (!this.$v!.emailAddress!.$invalid && !this.$v!.category!.$invalid &&
        !this.$v!.issueType!.$invalid && !this.$v!.comments!.$invalid &&
        !this.$v!.file!.$invalid && (this.emailAddress != null && this.emailAddress !== '') &&
        (this.category != null && this.category !== '') &&
        (this.issueType !== null && this.issueType !== '') &&
        (this.comments !== null && this.comments !== '') &&
        (this.file !== null && this.file !== '')) {
      return true;
    }
    return false;
  }

  isLoggedIn(): boolean {
    // return (localStorage.getItem(currentUserKey) &&
    //         this.$store.getters.getUserInfo &&
    //         this.$store.getters.getUserInfo.token &&
    //         this.$store.getters.getUserInfo.sessionId) ?
    //         true :
    //         false;
    return this.loggedIn || false;
  }

  // For title of the page
  get getHeaderConfig(): PageTitleConfig {
    return {
      pageTitle: this.$t('reportissues.signature_subhead')
      .toString(),
      pageParentName: '',
      isFetchFromProps: true,
      isShowDashboardIcon: this.loggedIn ? true : false,
      isShowSlash: this.loggedIn ? true : false,
      isShowParent: this.loggedIn ? true : false,
    };
  }

  created() {
    const currentUser = JSON.parse(
      localStorageKeeperService.retrieve('currentUser'),
    );
    if (currentUser && currentUser.email) {
      this.emailAddress = currentUser.email || '';
    }
  }
}
